module.exports = __webpack_public_path__ + "assets/img/3_1170.bb23d6dd.jpg";